module.exports = __webpack_public_path__ + "img/fruit-figs-190x100.1e9e53bc.jpg";